module.exports = __webpack_public_path__ + "static/media/obr_poz_1.19cf24be.jpg";